import {
  CHANGE_INPUT,
  FOCUS_INPUT,
  RESET_INPUTS,
  RESET_LOGIN,
  RESET_RECONSENT,
  RESET_TOTP,
  SET_IS_FIRST_PRE_AUTH_VISIT,
  TOGGLE_DRAWER,
  UPDATE_MFA_OPTIONS,
  VALIDATION_ERROR,
} from './constants';

export function changeInput({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: CHANGE_INPUT,
  };
}

export function focusInput({ field }) {
  return {
    payload: { field },
    type: FOCUS_INPUT,
  };
}

export function resetInputs() {
  return { type: RESET_INPUTS };
}

export function resetLogin() {
  return { type: RESET_LOGIN };
}

export function resetReconsent() {
  return { type: RESET_RECONSENT };
}

export function resetTotp() {
  return { type: RESET_TOTP };
}

export function setIsFirstPreAuthVisit() {
  return { type: SET_IS_FIRST_PRE_AUTH_VISIT };
}

export function toggleDrawer(drawerState) {
  return {
    payload: { drawerState },
    type: TOGGLE_DRAWER,
  };
}

export function updateValidationError({ error, field, form }) {
  return {
    payload: { error, field, form },
    type: VALIDATION_ERROR,
  };
}

export function updateMfaOptions({ mfaOptions }) {
  return {
    payload: { mfaOptions },
    type: UPDATE_MFA_OPTIONS,
  };
}
